import { render, staticRenderFns } from "./5-onboarding.vue?vue&type=template&id=5841a362&scoped=true&"
import script from "./5-onboarding.vue?vue&type=script&lang=js&"
export * from "./5-onboarding.vue?vue&type=script&lang=js&"
import style0 from "./5-onboarding.vue?vue&type=style&index=0&id=5841a362&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5841a362",
  null
  
)

export default component.exports